import TestCase from './TestCase';

export default class TestCasesCollection {
  testCases: Array<TestCase>;
  constructor(testCases: Array<TestCase> = []) {
    this.testCases = [...testCases];
  }

  isEmpty(): boolean {
    return this.testCases.length === 0;
  }
}
